module.exports = __webpack_public_path__ + "static/img/banner.5717321.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/banner.png
// module id = yFQr
// module chunks = 0